import App from '../app'
import Vue from 'vue'
import { errorHandlerMixin } from '../errorHandlerMixin'
import VueRecaptcha from 'vue-recaptcha'
import Axios from 'axios'
import QS from 'qs'

/* eslint-disable no-new */
new Vue({
  extends: App,
  components: {
    VueRecaptcha
  },
  mixins: [
    errorHandlerMixin
  ],
  data () {
    return {
      formLoading: false,
      form: {
        personalName: null,
        companyName: null,
        email: null,
        phone: null,
        body: null,
        // Honeypot: stays empty for real users; bots that fill every field trip it.
        website: null
      }
    }
  },
  methods: {
    submitForm () {
      // A second click while reCAPTCHA or the request runs would send a duplicate inquiry.
      if (this.formLoading) return
      this.formLoading = true
      this.$refs.recaptcha.execute()
    },
    resetCaptcha() {
      this.$refs.recaptcha.reset()
    },
    onCaptchaVerified (token) {
      this.form['g-recaptcha-response'] = token
      this.formLoading = true
      this.clearViolations()
      this.resetCaptcha()
      Axios.post('/kontakt', QS.stringify(this.form))
        .then(() => {
          this.form = {
            personalName: null,
            companyName: null,
            email: null,
            phone: null,
            body: null,
            website: null
          }
        })
        .catch((err) => {
          this.buildViolations(err.response)
        })
        .finally(() => {
          this.formLoading = false
        })
    }
  }
})
